import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { InvoiceService }               from './invoice.service';
import { InvoicesForBillerPaymentCtrl } from './invoices.for-biller-payment.ajs';
import { InvoicesForPaymentCtrl }       from './invoices.for-payment.ajs';
import { InvoiceStatusFilter }          from './invoice.status.filter.ajs';
import { InvoiceStatusPipe }            from './invoice.status.pipe';
import { InvoiceTypeFilter }            from './invoice.type.filter.ajs';
import { InvoiceTypePipe }              from './invoice.type.pipe';

angular.module('app-lite.invoices', [])
  .controller('InvoicesForBillerPaymentCtrl', InvoicesForBillerPaymentCtrl)
  .controller('InvoicesForPaymentCtrl', InvoicesForPaymentCtrl)
  .filter('invoiceStatus', InvoiceStatusFilter)
  .filter('invoiceType', InvoiceTypeFilter)
  .service('invoiceApi', downgradeInjectable(InvoiceService))
  .service('invoiceStatusPipe', downgradeInjectable(InvoiceStatusPipe))
  .service('invoiceTypePipe', downgradeInjectable(InvoiceTypePipe));